import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import { Button, Table, Row, Col, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import formatDistanceStrict from 'date-fns/formatDistanceStrict';
import {
    CONFIG_BASE_API_URL,
} from '../constans';

export class TrainingExamResultPage extends Component {
    static displayName = TrainingExamResultPage.name;

    constructor(props) {
        super(props);
        this.state = { trainingResult: null, loading: true };

        this.renderTrainingDetail = this.renderTrainingDetail.bind(this);
    }

    componentDidMount() {
         this.populateTrainingDetailData();
    }

    renderTrainingDetail() {
        var startDate = new Date(Date.parse(this.state.trainingResult.startTime));
        var stopTime = new Date(Date.parse(this.state.trainingResult.stopTime));
        var difference = formatDistanceStrict(stopTime, startDate);
        var formatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };

            return (
                <React.Fragment>

                    <Row>
                        <Col className="pt-2">
                            <h2>{this.state.trainingDefinition.name} </h2>
                            <h6>{this.state.trainingDefinition.description}</h6>
                            <hr/>
                        </Col>
                    </Row>
                    <Row >
                        <Col xs="12" className="border shadow-sm p-4">
                            <Row>
                                <Col xs="12" sm="7" className="font-weight-bold text-center border-right my-3 px-5">
                                    <h4>JOUW SCORE</h4>
                                    <div className="display-1 pb-3" style={{fontWeight: 600}}>{this.state.trainingResult.score}%</div>
                                    {this.state.trainingResult.state === 1 ?
                                        <h4 className="text-left"><b>Gefeliciteerd!</b> Je hebt dit examen gehaald. Bekijk je resultaten en op naar het volgende examen!</h4>
                                        :
                                        <h4 className= "text-left"><b>Helaas!</b> Je hebt dit examen niet gehaald. Bekijk je resultaten en probeer het later nogmaals!</h4>
                                    }
                                </Col>
                                <Col xs="12" sm="5" className="font-weight-bold text-left my-3 px-5">
                                    <Row>
                                        <Col xs="5" className="font-weight-bold">Start:</Col>
                                        <Col xs="auto">{startDate.toLocaleDateString("nl-NL", formatOptions)}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs="5" className="font-weight-bold">Duur:</Col>
                                        <Col xs="auto">{difference}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs="5" className="font-weight-bold">Aantal vragen:</Col>
                                        <Col xs="auto">{this.state.trainingResult.questions.length}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs="5" className="font-weight-bold">Aantal fout:</Col>
                                        <Col xs="auto">{this.state.wrongAnswerCount}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs="12" className="border shadow-sm text-left p-4 my-3">
                            <Table responsive hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Vraag</th>
                                        <th>Jouw Antwoord</th>
                                        <th>Resultaat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.trainingResult.questions.map((question) => {

                                        var myAnswer = question.trainingResultMultipleChoiceAnswerOptions.find(element => element.isSelected == true);
                                        if (typeof myAnswer === 'undefined') {
                                            return "";
                                        }
                                        var isCorrect = (myAnswer.isCorrect);

                                        return (
                                            <tr key={question.id} >
                                                <td scope="row" className="small">{question.savedText.text}</td>
                                                <td scope="row" className="small">{myAnswer.text}</td>

                                                <td scope="row">
                                                    {isCorrect ?
                                                        <div className="badge badge-success">Goed</div>
                                                        :
                                                        <div className="badge badge-danger">Fout</div>
                                                    }
                                                    </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <div className="text-left">
                        <Button className="mb-5 mt-3" tag={Link} to={"/training/" + this.state.trainingResult.trainingId} color="primary">
                            Terug naar training
                         </Button>
                    </div>
                </React.Fragment>
            );
    }
    render() {

        if (this.state.errorMessage != null) {
            return (
                <React.Fragment>
                    <div className="pt-5 text-center"><h4 className="pt-5">{this.state.errorMessage}</h4></div>
                </React.Fragment>
            );
        } else {

            let contents = this.state.loading
                ?
                <Row>
                    <div className="col-sm center-loading-spinner">
                        <Spinner className="spinner-settings" type="border" color="primary" />
                        <div className="pt-4">Examen resultaat data laden...</div>
                    </div>
                </Row>
                : this.renderTrainingDetail();

            return (
                <React.Fragment>
                    {contents}
                </React.Fragment>
            );
        }
    }
    //GetAvailableTrainingsAsync
    async populateTrainingDetailData() {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/trainingresult/' + this.props.match.params.id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
            this.setState({
                errorMessage: data.foutmelding,
                loading: false
            });
        } else {
            this.setState({
                trainingResult: data.responseData.trainingResult,
                correctAnswerCount: data.responseData.correctAnswerCount,
                wrongAnswerCount: data.responseData.wrongAnswerCount,
                trainingResult: data.responseData.trainingResult,
                trainingDefinition: data.responseData.trainingDefinition,
                student: data.responseData.student,
                loading: false
            });
        }
    }
}

